import I18n from 'I18n';
export const getListTriggerOption = () => ({
  text: I18n.text('createWorkflow.triggerOptions.list.title'),
  description: I18n.text('createWorkflow.triggerOptions.list.description'),
  type: 'LIST',
  value: 'LIST'
});
export const getScheduledTriggerOption = () => ({
  text: I18n.text('createWorkflow.triggerOptions.scheduled.title'),
  type: 'SCHEDULED',
  value: 'SCHEDULED'
});
export const getManualTriggerOption = () => ({
  text: I18n.text('createWorkflow.triggerOptions.manual.title'),
  type: 'MANUAL',
  value: 'MANUAL'
});
export const getWebhookTriggerOption = () => ({
  text: I18n.text('createWorkflow.triggerOptions.webhook.title'),
  description: I18n.text('createWorkflow.triggerOptions.webhook.description'),
  type: 'WEBHOOK',
  value: 'WEBHOOK'
});